export const SET_INITIAL_CRUD_FORM_STATE = "SET_INITIAL_CRUD_FORM_STATE";
export const TOGGLE_CRUD_FORM_TABLE_LOADING = "TOGGLE_CRUD_FORM_TABLE_LOADING";
export const TOGGLE_CRUD_FORM_FORM_LOADING = "TOGGLE_CRUD_FORM_FORM_LOADING";
export const SET_CRUD_FROM_FIELDS = "SET_CRUD_FROM_FIELDS";
export const SET_INITIAL_DROPDOWN_FORM_STATE =
  "SET_INITIAL_DROPDOWN_FORM_STATE";
export const SET_CRUD_SEARCH_FIELDS = "SET_CRUD_SEARCH_FIELDS";
export const SET_ALL_CRUD_FROM_FIELDS = "SET_ALL_CRUD_FROM_FIELDS";
export const SET_ALL_CRUD_SEARCH_FIELDS = "SET_ALL_CRUD_SEARCH_FIELDS";
export const RESET_FORM_FIELDS = "RESET_FORM_FIELDS";
export const RESET_SEARCH_FIELDS = "RESET_SEARCH_FIELDS";
export const SET_MULTI_CRUD_FORM_FIELD = "SET_MULTI_CRUD_FORM_FIELD";
export const SET_MULTI_CRUD_SEARCH_FIELD = "SET_MULTI_CRUD_SEARCH_FIELD";
export const SET_MULTI_CRUD_SUPPORTINGTABLE = "SET_MULTI_CRUD_SUPPORTINGTABLE"
export const SET_MODAL_TOGGLE_FOR_ACTION = "SET_MODAL_TOGGLE_FOR_ACTION";